import http from "@/http-common";

const BASE = "statistics/tuition";

class TuitionStatisticsService {
  getSummary(startMonth, endMonth) {
    return http.get(`${BASE}/summary`, { params: { startMonth, endMonth } });
  }
}

export default new TuitionStatisticsService();
